import { yup } from '../initYup';

declare module 'yup' {
  interface StringSchema {
    /**
     * Controlla che il valore inserito sia un numero
     */
    isNumber(): StringSchema;
  }
}

/**
 * Controlla che il valore inserito sia un numero
 */
yup.addMethod(yup.string, 'isNumber', function () {
  return this.test({
    name: 'isNumber',
    message: 'il campo ${label} deve essere un numero',
    test: value => {
      if (!value) {
        return true;
      }

      return !isNaN(Number(value));
    },
  });
});
